import { Controller } from "@hotwired/stimulus";
import Chart from 'chart.js/auto';
import ChartDataLabels from "chartjs-plugin-datalabels";

export default class PieChartController extends Controller {
    connect() {
        let labels = JSON.parse(this.element.dataset.labels);
        let chartData = JSON.parse(this.element.dataset.chartData);
        let chartType = this.element.dataset.chartType || "pie";
        let percentage = this.element.dataset.percentage || false;

        let tick_function;
        if (percentage === "true") {
            tick_function = function (label, index, labels) {
                return label + " %";
            };
        } else {
            tick_function = function (label, index, labels) {
                return label;
            };
        }

        this.chart = new Chart(
            this.element,
            {
                type: chartType,
                plugins: [ChartDataLabels],
                data: {
                    labels: labels,
                    datasets: [
                        {
                            data: chartData
                        }
                    ]
                },
                options: {
                    plugins: {
                        tooltip: {
                            enabled: true,
                        },
                        datalabels: {
                            color: "#2a2929",
                            font: {
                                weight: "normal",
                                size: 11,
                            },
                            formatter: tick_function,
                        },
                    }
                }
            }
        );
    }
}
